import {
  partner_pack_icon,
  family_pack_icon,
  customize_pack_icon,
  party_pack_icon,
} from '../../../assets/svg/svg';
export const Packages = [
  {
    title: 'Partner Pack',
    icon: <>{partner_pack_icon}</>,
    desc: 'Ullamcorper porttitor mattis vel maecenas quisque tincidunt. Sem enim sagittis, sagittis enim pharetra  ',
  },

  {
    title: 'Family Pack',
    icon: <>{family_pack_icon}</>,
    desc: 'Ullamcorper porttitor mattis vel maecenas quisque tincidunt. Sem enim sagittis, sagittis enim pharetra ',
  },

  {
    title: 'Customize Pack',
    icon: <>{customize_pack_icon}</>,
    desc: 'Ullamcorper porttitor mattis vel maecenas quisque tincidunt. Sem enim sagittis, sagittis enim pharetra ',
  },

  {
    title: 'Party Pack',
    icon: <>{party_pack_icon}</>,
    desc: 'Ullamcorper porttitor mattis vel maecenas quisque tincidunt. Sem enim sagittis, sagittis enim pharetra ',
  },
];

export const base_location_set1 = [
  { location: 'Elekahia' },
  { location: 'Stadium road' },
  { location: 'Airforce' },
  { location: 'Nkpogu' },
  { location: 'Peter Odili' },
];
export const base_location_set2 = [
  { location: 'Rumuomasi' },
  { location: 'Market Junction' },
  { location: 'Parbole' },
  { location: 'Audinance' },
  { location: 'Shell I.A' },
];

// import review_img from '../../../assets/images/review_img.png';

export const reviews = [
  {
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1666789104/savory/review_img_ayhent.png',
    name: 'John Doe1',
    address: 'Elekahia, PH',
    desc: 'Lacus imperdiet eleifend odio et, erat convallis quam. Sollicitudin nulla adipiscing sodales proin dui. Fames pulvinar sed enim, amet.',
  },

  {
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1666789104/savory/review_img_ayhent.png',
    name: 'John Doe',
    address: 'Elekahia, PH',
    desc: 'Lacus imperdiet eleifend odio et, erat convallis quam. Sollicitudin nulla adipiscing sodales proin dui. Fames pulvinar sed enim, amet.',
  },

  {
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1666789104/savory/review_img_ayhent.png',
    name: 'John Doe',
    address: 'Elekahia, PH',
    desc: 'Lacus imperdiet eleifend odio et, erat convallis quam. Sollicitudin nulla adipiscing sodales proin dui. Fames pulvinar sed enim, amet.',
  },

  {
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1666789104/savory/review_img_ayhent.png',
    name: 'John Doe',
    address: 'Elekahia, PH',
    desc: 'Lacus imperdiet eleifend odio et, erat convallis quam. Sollicitudin nulla adipiscing sodales proin dui. Fames pulvinar sed enim, amet.',
  },

  {
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1666789104/savory/review_img_ayhent.png',
    name: 'John Doe',
    address: 'Elekahia, PH',
    desc: 'Lacus imperdiet eleifend odio et, erat convallis quam. Sollicitudin nulla adipiscing sodales proin dui. Fames pulvinar sed enim, amet.',
  },
];
